export function extractFileName(url) {
  if (!url) return null;

  // Get the last part after last `/`
  let lastPart = url.split("/").pop(); // e.g. "master-uuid-1759134665319.mp3"

  // Remove "engineer/" prefix if present
  if (lastPart.startsWith("engineer/")) {
    lastPart = lastPart.replace("engineer/", "");
  }

  // Remove extension
  const withoutExt = lastPart.replace(/\.[^/.]+$/, "");

  // Split into parts
  const parts = withoutExt.split("-");

  let name;
  if (parts.length >= 2) {
    const prefix = parts[0]; // "master"
    const timestamp = parts[parts.length - 1]; // "1759134665319"
    name = `${prefix}-${timestamp}`;
  } else {
    name = withoutExt; // fallback
  }

  return name
}